export const STORYBLOK_WEBSITE_ROOT = 'website';
